import {
  Directive,
  effect,
  inject,
  Input,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { AuthStore } from '../stores/auth.store';

@Directive({
  selector: '[appHasPrivilege]',
  standalone: true,
})
export class HasPrivilegeDirective {
  private authStore = inject(AuthStore);
  private viewContainerRef = inject(ViewContainerRef);
  private templateRef = inject(TemplateRef);

  @Input() set appHasPrivilege(expectedPrivileges: string[]) {
    this.expectedPrivileges = expectedPrivileges ?? [];
    this.evaluateVisibility();
  }

  private expectedPrivileges: string[] = [];

  constructor() {
    effect(() => {
      this.evaluateVisibility();
    });
  }

  private evaluateVisibility() {
    const user = this.authStore.currentUser();

    if (!user?.privileges?.length || !this.expectedPrivileges.length) {
      this.viewContainerRef.clear();
      return;
    }

    const userPrivileges = new Set(user.privileges.map((p) => p.actionCode));

    const hasPrivilege = this.expectedPrivileges.some((priv) =>
      userPrivileges.has(priv),
    );

    if (hasPrivilege) {
      if (this.viewContainerRef.length === 0) {
        this.viewContainerRef.createEmbeddedView(this.templateRef);
      }
    } else {
      this.viewContainerRef.clear();
    }
  }
}
